/**
 * Registro de tours realizados.
 *
 * Esto NO decide si un tour se muestra: el tour siempre está disponible en el
 * botón flotante. Solo deja constancia de quién hizo cuál y hasta dónde llegó,
 * para la tabla de tours por usuario.
 *
 * Por eso el adaptador por defecto no hace nada: mientras la tabla no exista,
 * el editor funciona igual. Cuando esté lista, se conecta en un solo lugar
 * (típicamente al arrancar la app) y ningún componente se entera:
 *
 *   setTourTracking({
 *     record: ({ tourId, status, stepReached, totalSteps }) =>
 *       Dynamipay(SERVICES.TOURS).post({ tour: tourId, status, stepReached, totalSteps }),
 *   });
 */

const noopTracking = {
  async record() {
    // Sin backend todavía: el tour funciona, solo no se registra.
  },
};

let adapter = noopTracking;

export const setTourTracking = (next) => {
  adapter = next || noopTracking;
};

/**
 * @param {object} event
 * @param {string} event.tourId    id del tour del catálogo
 * @param {string} event.status    'completed' | 'skipped'
 * @param {number} event.stepReached  último paso visto (base 1)
 * @param {number} event.totalSteps   pasos del tour
 */
export const recordTour = async (event) => {
  try {
    await adapter.record({
      ...event,
      at: new Date().toISOString(),
    });
  } catch (error) {
    // Registrar el tour nunca debe romper la pantalla que lo muestra.
    console.error('No se pudo registrar el tour:', error);
  }
};
